import React from "react"
import axios from "axios";
import { setup as URI_SETUP } from "../../../../config/api";
import { exists } from "fs";

const uri_catalogs = URI_SETUP+"catalog";


class CorporativeParsing extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            catalog_list                    : [],
            catalog_alias_list              : [],
            selected_catalog                : {
                                                    _id         : "",
                                                    name        : {
                                                        en : "",
                                                        es : "",
                                                    }   
                                                },
            catalog_item                    : {
                                                _id         : "",
                                                name        : ""
                                            },
            status_catalog_listing          : "hide",
            status_catalog_item_modal       : "hide",
            catalog_item_action             : "new",
            catalog_item_open               : "",
            background_filter               : "",
            status_magnum_leap_hotel        : "hide",
            status_sub_category             : "hide",
            dragged_over                    : ""

            }
    }

    componentWillMount(){
    }

    // ----------------------- Handlers -----------------------

    handleCatalogItemOpen(id){
        let item_opened = "";
        if(this.state.catalog_item_open!=id){
            item_opened = id;
        }
        this.setState({ 
            catalog_item_open             : item_opened
            }) 
    }

    handleCatalogSelector(catalog) {
        let self = this;
        axios.get(uri_catalogs+"/"+catalog.id, { 
            params: {
                api_token   : localStorage.getItem("api_token"),
                mode        : 'parsing' 
            }
        }).then(request => { 
            self.setState({ 
            catalog_list             : request.data,
            selected_catalog         : catalog,
            status_catalog_listing   : ""
            }) 
        })
    }

    // ----------------------- Functions -----------------------

    onDragStart = (ev, id) => {
        ev.dataTransfer.setData("id", id);
    }

    onDragOver = (ev,id) => {
        ev.preventDefault();
        this.setState({ 
            dragged_over            : id
            })

    }

    onDragLeave = (ev) => {
        ev.preventDefault();
        this.setState({ 
            dragged_over            : ""
            })

    }

    onDrop = (ev, alias_id) => {
       let id = ev.dataTransfer.getData("id");
       var qs = require("qs");
       const valuesToSent = qs.stringify({
            alias_id    : alias_id,
            action      : 'assign_alias'
        });
       axios.post(uri_catalogs+"/"+this.state.selected_catalog.id+"/"+id, valuesToSent)
                    .then(request => {  
                        this.handleCatalogSelector(this.state.selected_catalog);
                        this.props.refreshCatalogSys();
                        this.setState({ 
                            dragged_over            : ""
                            })
                    })  
    }

    unassignAlias (id) {
        var qs = require("qs");
        const valuesToSent = qs.stringify({
             action      : 'unassign_alias'
         });
        axios.post(uri_catalogs+"/"+this.state.selected_catalog.id+"/"+id, valuesToSent)
                     .then(request => {  
                         this.handleCatalogSelector(this.state.selected_catalog);
                         this.props.refreshCatalogSys();
                     })  
     }

    // ----------------------- Renders -----------------------

    renderCatalogs() {
        let self = this;
        return <ul>
                    {   
                        this.props.catalogs.map(function(catalog, i) {
                            if(catalog.type.indexOf("general")>=0){
                                return (<li className="clickable" key={catalog.id} onClick={self.handleCatalogSelector.bind(self, catalog)} >
                                    <div>{catalog.name.en}  
                                        <i className="fa fa-angle-down"></i>
                                        <span className= {"float-right " + ((catalog.pendings==0)? "circle-note gray" : "circle-note red"  )} > {(catalog.pendings==0)? catalog.assigned : catalog.pendings  } </span>
                                    </div>
                                </li>);
                                }
                            })
                    }
                </ul>   
    }

    renderCatalogItems() {
        return  <ul>
                    <li className="list-header">
                            <div className="label">
                                {this.state.selected_catalog.name.en} 
                                <i className="fa edit fa-plus-circle clickable" onClick={this.props.activeSection.bind(this,"setup","corporative-catalogs","",this.state.selected_catalog)}></i>
                            </div>
                    </li>
                    {Object.keys(this.state.catalog_list).map((key, index) => {
                        if (!this.state.catalog_list[key].imported){
                            return (<li key={this.state.catalog_list[key]._id.$oid} 
                                        className={"sub-list " + (this.state.catalog_item_open==this.state.catalog_list[key]._id.$oid? "" : "collapsed" )}
                                    >
                                        <div
                                        className={(this.state.dragged_over==this.state.catalog_list[key]._id.$oid)?"dragged-over":""}
                                        onDragOver={(e)=>this.onDragOver(e, this.state.catalog_list[key]._id.$oid)}
                                        onDragLeave={(e)=>this.onDragLeave(e)}
                                        onDrop={(e)=>{this.onDrop(e, this.state.catalog_list[key]._id.$oid)}}>
                                            {this.state.catalog_list[key].name}
                                            <i  className={"clickable fa " + (this.state.catalog_item_open==this.state.catalog_list[key]._id.$oid? "fa-angle-up" : "fa-angle-down" )} 
                                                onClick={this.handleCatalogItemOpen.bind(this,this.state.catalog_list[key]._id.$oid)} >
                                            </i>

                                            <span className= {(this.state.catalog_list[key].alias_total==0)? "hidden" : "float-right circle-note gray"  } > {this.state.catalog_list[key].alias_total} </span>
                                        </div>
                                        {this.renderCatalogAliasItems(this.state.catalog_list[key]._id.$oid, this.state.catalog_list[key].alias_list)}
                                    </li>);
                            }
                        }
                    )
                        
                    }
                </ul>   
    }

    renderCatalogAliasItems(id,alias_list) {
        return  <ul className="alias-listing" 
                    onDragOver={(e)=>this.onDragOver(e, id)}
                    onDrop={(e)=>{this.onDrop(e, id)}}>
                        {Object.keys(alias_list).map((key, index) => {
                            return (<li key={alias_list[key]._id.$oid} >
                                        <div>{alias_list[key].name}<i className="fa fa-times-circle remove clickable" onClick={this.unassignAlias.bind(this,alias_list[key]._id.$oid)} ></i></div>
                                    </li>);
                            }
                        )   
                    }   
                </ul>   
    }

    renderImportedItems() {
        return  <ul>
                    <li className="sub-list" ><div>{this.state.selected_catalog.name.en} <i className="fa fa-angle-down"></i>  </div>
                        <ul>
                             {Object.keys(this.state.catalog_list).map((key, index) => {
                                if (this.state.catalog_list[key].imported && this.state.catalog_list[key].magnum_alias == exists){
                                    return (<li key={this.state.catalog_list[key]._id.$oid} className="clickable" draggable="true" onDragStart = {(e) => this.onDragStart(e, this.state.catalog_list[key]._id.$oid)} >
                                                <div>{this.state.catalog_list[key].name}</div>
                                            </li>);
                                    }
                                })
                            }
                        </ul>
                    </li>
                        
                </ul>   
    }

    render() {
        return (
            <section>
                <div className={this.state.background_filter}>
                    <div className="head-content "> 
                        <div className="col-md-12 px-2">    
                            <h1>Setup</h1>
                            <h2>PARSING CORPORATIVE DATA BASE</h2>
                        </div>
                    </div>

                    <div className="col-md-12 no-padding"> 
                        <div className="box regular col-md-4">
                            <h3>MAGNUM LEAP CORP</h3>
                            <div className="list-in-box">
                                {this.renderCatalogs()}
                            </div>
                        </div>
                        <div className={"box regular col-md-4 " + this.state.status_catalog_listing}>
                            <h3>SUB CATEGORY</h3>
                            <div className="list-in-box">
                                {this.renderCatalogItems()}
                            </div>
                        </div>
                        <div className={"box regular col-md-4 " + this.state.status_catalog_listing}>
                            <h3>PMS HOTEL</h3>
                            <div className="list-in-box">
                            {this.renderImportedItems()}
                            </div>
                        </div>
                    </div>
                </div>

            </section>
        )
    }

}

export default CorporativeParsing


// WEBPACK FOOTER //
// ./src/Setup/modules/setup/views/corporative/CorporativeParsing.js